import "./src/styles/global.css"
import "@fontsource/poppins"
import "@fontsource/poppins/300.css"
import "@fontsource/poppins/400.css"
import "@fontsource/poppins/500.css"
import "@fontsource/red-hat-display"
import "@fontsource/red-hat-display/600.css"
import "@fontsource/red-hat-display/700.css"
import "@fontsource/red-hat-display/800.css"
import "@fontsource/figtree"
import "@fontsource/figtree/400.css"
import "@fontsource/figtree/400-italic.css"
import "@fontsource/figtree/500-italic.css"
import "@fontsource/figtree/700.css"

export const onClientEntry = () => {
  const script = document.createElement('script');
  script.src = 'https://t.contentsquare.net/uxa/a5c284951be3c.js';
  script.async = true;
  document.head.appendChild(script);
};


